import { defineMessages } from 'react-intl';

const messages = defineMessages({
  user_status: `{status, select,
    active {可用}
    locked {禁用}
    undefined {状态}
  }`,
  status: `{status, select,
    active {可用}
    locked {禁用}
    undefined {状态}
  }`,
  user_login: '登录账号',
  user_name: '用户名',
  user_email: '邮箱',
  user_popo: 'POPO账号',
  user_password: '登录密码',
  userPasswordTooltip: '6-16位，区分大小写，只能使用字母、数字或特殊字符。',
  userPasswordPlaceholder: '( 不修改密码 )',
  add_account: '添加账号',
  pedding_assign: '待分配',
});

export default messages;
